



















import { Vue, Component, Prop } from "vue-property-decorator";
import { MDialog, MMessage } from "@ulaval/modul-components";
import store from "../store";

@Component({
  components: {
    MDialog,
    MMessage,
  },
})
export default class FenetreTempsAlloueEchu extends Vue {
  @Prop({ type: Function })
  private surFermeture!: () => Promise<void>;

  get afficherFenetreTempsAlloueEchu(): boolean {
    return store.state.minuteur.tempsAlloueEchu;
  }
}
